import { gql } from "@apollo/client";

export const GET_TIMELINE_EDITOR = gql`
  query GetTimelineEditor($matchId: ID!) {
    timelineEditor(matchId: $matchId) {
      header {
        mapName
        tickRate
        totalTicks
      }
      players {
        steamId
        name
        observerSlot
        avatar
      }
      rounds {
        round
        startTick
        endTick
        winner
        terroristsScore
        counterTerroristsScore
        kills {
          tick
          killer
          victim
          location
          killerData {
            weapon
            headShot
            team
          }
        }
        bomb {
          tick
          type
          site
          initiator
        }
      }
    }
  }
`;
